import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { useState } from 'react';
import { PhoneInputWrapper, Text } from './PhoneNumberInput.style';
import { isValidPhoneNumber } from 'libphonenumber-js';

const PhoneNumberInput = ({
  phone,
  setPhone,
  autoFocus,
  defaultCode,
  callingCode,
  disabled,
  style,
  wrapperWidth,
  placeholder,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <PhoneInputWrapper style={{ width: wrapperWidth }}>
      <PhoneInput
        searchStyle={{
          borderRadius: 20,
          color: '#000',
          padding: '5px 10px',
        }}
        placeholder={placeholder}
        containerStyle={style}
        enableSearch={true}
        defaultCountry={defaultCode}
        disableSearchIcon={true}
        countryCodeEditable={false}
        country={'us'}
        specialLabel={false}
        value={phone.formattedValue}
        onChange={(value, _, e, formattedValue) => {
          setPhone({ value: '+' + value, formattedValue });
        }}
        inputProps={{
          autoFocus: autoFocus,
          disabled: disabled,
          onFocus: () => setFocused(true),
          onBlur: () => {
            setFocused(false);
          },
        }}
        countrySelectProps={{
          onBlur: () => setFocused(false),
          onFocus: () => setFocused(true),
          onChange: country => {},
        }}
      />
      {(!focused || !isValidPhoneNumber(phone.value ? phone.value : '')) && <Text>{placeholder}</Text>}
    </PhoneInputWrapper>
  );
};

export default PhoneNumberInput;
